import * as React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export default class ResetPasswordComponent
extends React.Component<ResetPasswordComponentProps> {
	render() {
		const submitting = this.props.submitting

		return <div className="hero is-fullheight">
			<div className="hero-body">
				<div className="container">
					<div className="columns">
						<form className="column is-4 is-offset-4" onSubmit={this.props.onSubmit}>

							<div className="field">
								<label className="label" htmlFor={Names.password}>Mot de passe</label>
								<div className={`control has-icons-left ${submitting ? "is-loading": ""}`}>
									<input
									className="input"
									disabled={submitting}
									name={Names.password}
									placeholder = "Mot de passe"
									type="password"
									required />
									<span className="icon is-left">
										<FontAwesomeIcon icon="lock" />
									</span>
								</div>
							</div>

							<div className="field">
								<label className="label" htmlFor={Names.passwordConfirm}>Confirmation mot de passe</label>
								<div className={`control has-icons-left ${submitting ? "is-loading": ""}`}>
									<input
									className="input"
									disabled={submitting}
									name={Names.passwordConfirm}
									placeholder="Confirmation mot de passe"
									type="password"
									required />
									<span className="icon is-left">
										<FontAwesomeIcon icon="lock" />
									</span>
								</div>
							</div>

							<div className="field">
								<button className={`button is-primary ${submitting ? "is-loading": ""}`} disabled={submitting}>
									Modifier le mot de passe
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	}
}

export const Names = {
	password: "plainPassword.first",
	passwordConfirm: "plainPassword.second"
}

export interface ResetPasswordComponentProps {
	submitting: boolean
	onSubmit(e: React.SyntheticEvent<any>): void
}



// WEBPACK FOOTER //
// ./src/route/reset-password/reset-password-component.tsx